import { LegalLayout } from "@/components/site/LegalLayout";
import { CABINET, PHOTOS } from "@/lib/content";

const TODO = ({ children }) => <mark className="bg-[#E5DEC9] px-1 text-[#1C2826]">{children}</mark>;

export default function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" eyebrow="Informations réglementaires" testid="mentions-legales-page">
      <h2>Éditeur du site</h2>
      <p>
        {CABINET.firm} — {CABINET.name}, avocate au barreau d'Aix-en-Provence<br />
        Prestation de serment : {CABINET.serment}<br />
        Cabinet : {CABINET.address.join(", ")}<br />
        Téléphone : <a href={CABINET.phoneHref}>{CABINET.phone}</a> · Portable : <a href={CABINET.mobileHref}>{CABINET.mobile}</a> · E-mail : <a href={`mailto:${CABINET.email}`}>{CABINET.email}</a><br />
        SIREN / SIRET : {CABINET.siret}<br />
        N° TVA intracommunautaire : FR42 818 106 643
      </p>
      <p>Directrice de la publication : Maître Pauline Rège Chanal.</p>

      <h2>Profession réglementée</h2>
      <p>
        Avocate inscrite au barreau d'Aix-en-Provence — Ordre des avocats du barreau d'Aix-en-Provence, Palais Verdun, 20 place de Verdun, 13100 Aix-en-Provence.
        Titre professionnel : avocat, obtenu en France. La profession est soumise à la loi n° 71-1130 du 31 décembre 1971, au décret n° 2023-552 du 30 juin 2023
        portant code de déontologie des avocats et au Règlement Intérieur National de la profession d'avocat (RIN), consultables sur{" "}
        <a href="https://www.cnb.avocat.fr" target="_blank" rel="noopener noreferrer">www.cnb.avocat.fr</a>.
      </p>

      <h2>Assurance responsabilité civile professionnelle</h2>
      <p>
        Assureur : MMA IARD Assurances Mutuelles — contrat n° 127.129.204 souscrit par le Barreau d'Aix-en-Provence.<br />
        Couverture géographique : France.
      </p>

      <h2>Médiation de la consommation</h2>
      <p>
        Conformément aux articles L.612-1 et suivants du code de la consommation, en cas de litige avec un client consommateur non résolu
        par une réclamation préalable écrite adressée à l'avocate, le client peut saisir gratuitement le Médiateur de la consommation de la profession d'avocat :
      </p>
      <ul>
        <li>Médiateur de la consommation de la profession d'avocat — 180 boulevard Haussmann, 75008 Paris</li>
        <li>Site : <a href="https://mediateur-consommation-avocat.fr" target="_blank" rel="noopener noreferrer">mediateur-consommation-avocat.fr</a></li>
        <li>E-mail : <a href="mailto:mediateur@mediateur-consommation-avocat.fr">mediateur@mediateur-consommation-avocat.fr</a></li>
      </ul>
      <p>Les différends relatifs aux honoraires relèvent par ailleurs de la procédure de contestation devant le Bâtonnier de l'Ordre (art. 174 et s. du décret du 27 novembre 1991).</p>

      <h2>Hébergement</h2>
      <p>
        Emergent Labs Inc. — 255 California Street, Suite 550, San Francisco, CA 94111, États-Unis.<br />
        Contact : <a href="mailto:support@emergent.sh">support@emergent.sh</a> · <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer">emergent.sh</a>
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        Les textes de ce site sont la propriété de l'éditrice. La photographie du palais de justice est reproduite sous licence Creative Commons :
        « {PHOTOS.hero.title} » par {PHOTOS.hero.author} (<a href={PHOTOS.hero.licenseUrl} target="_blank" rel="noopener noreferrer">{PHOTOS.hero.license}</a>, <a href={PHOTOS.hero.source} target="_blank" rel="noopener noreferrer">source</a>).
        L'image a été compressée et assombrie ; cette adaptation est diffusée sous la même licence. Le portrait de Maître Pauline Rège Chanal est protégé : droits réservés, toute reproduction est interdite.
      </p>

      <h2>Information</h2>
      <p>
        Les informations présentées sur ce site sont d'ordre général. Elles ne constituent ni une consultation juridique, ni une promesse de résultat :
        chaque situation fait l'objet d'une analyse individuelle.
      </p>
    </LegalLayout>
  );
}
